import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import About from '../components/about/About';
import MainLayout from '../components/layouts/main';

import Projects from '../components/projects/Projects';
import { AllProjectsJson, AllTagsJson } from '../types/common';
import Contacts from '../components/contacts/Contacts';

type DataType = {
  allProjectsJson: AllProjectsJson;
  allTagsJson: AllTagsJson;
};
const IndexPage = () => {
  const data = useStaticQuery<DataType>(graphql`
    {
      allProjectsJson {
        edges {
          node {
            id
            title
            slug
            tags
            repository
            url
            finishDate
            description
            img {
              path {
                childImageSharp {
                  gatsbyImageData(width: 500, placeholder: BLURRED)
                }
              }
            }
          }
        }
      }
      allTagsJson {
        edges {
          node {
            color
            id
            tag
            tagId
          }
        }
      }
    }
  `);

  const { allProjectsJson, allTagsJson } = data;
  const projects = allProjectsJson.edges.map((edge) => edge.node);
  const tags = allTagsJson.edges.map((edge) => edge.node);

  return (
    <MainLayout>
      <About />
      <Projects projects={projects} tags={tags} />
      <Contacts />
    </MainLayout>
  );
};
export default IndexPage;
